import { InjectionToken } from '@angular/core';
export const DOCUMENT_TOKEN = new InjectionToken<Document>('Window document object');
